/**
 * Machine-readable error codes for the prescriber credentials API. The shared
 * problem details filter keeps only `detail`, so the server puts the code
 * string in the exception message and clients match on it.
 */ /**
 * HTTP 409: the `version` sent no longer matches the stored profile, a first
 * save (`version: 0`) arrived after someone else's, or a version above 0 was
 * sent for a user with no profile. The client refetches.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRESCRIBER_NOT_A_DOCTOR () {
        return PRESCRIBER_NOT_A_DOCTOR;
    },
    get PRESCRIBER_PROFILE_VERSION_CONFLICT () {
        return PRESCRIBER_PROFILE_VERSION_CONFLICT;
    }
});
const PRESCRIBER_PROFILE_VERSION_CONFLICT = 'PRESCRIBER_PROFILE_VERSION_CONFLICT';
const PRESCRIBER_NOT_A_DOCTOR = 'PRESCRIBER_NOT_A_DOCTOR';
